/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import AddIcon from "components/RevampFeedDetails/assets/AddIcon";
import MinusIcon from "components/RevampFeedDetails/assets/MinusIcon";

const FAQs = ({ faqs }) => {
	const [faqsList, setFaqsList] = useState(faqs);

	useEffect(() => {
		setFaqsList(faqs);
	}, [faqs]);

	const toggleFaq = (index) => {
		setFaqsList((prevFaqs) =>
			prevFaqs.map((faq, i) =>
				i === index ? { ...faq, isExpanded: !faq.isExpanded } : faq
			)
		);
	};

	return (
		<div>
			{Array.isArray(faqsList) &&
				faqsList.length > 0 &&
				faqsList.map((faq, index) => (
					// eslint-disable-next-line react/jsx-no-comment-textnodes
					<div className="my-[16px]" key={faq.question}>
						<div
							className="flex cursor-pointer items-center justify-between"
							onClick={() => toggleFaq(index)}
						>
							<p className="m-0 w-[80%] text-left text-[14px] font-semibold leading-[24px] md:text-[16px]">
								{faq.question}
							</p>
							<div className="flex h-[32px] w-[32px] items-center justify-center self-start rounded-full bg-[#EAF8F4] text-green-600">
								{faq.isExpanded ? <MinusIcon /> : <AddIcon />}
							</div>
						</div>
						{faq.isExpanded && (
							<div className="w-[80%] overflow-hidden text-[14px] font-normal text-[#8C8594] md:text-[16px]">
								<div
									className="no-margin"
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{
										__html: faq.answer.replace(
											/<p>/g,
											'<p style="margin: 0;">'
										),
									}}
								/>
							</div>
						)}
					</div>
				))}
		</div>
	);
};

export default FAQs;
